import styled, { css } from "styled-components";
import Container from "../../atoms/Container/Container.styled";
import {
  StyledButton,
  StyledButtonLink,
} from "../../atoms/Button/Button.styled";
import { withAnchorOffset, withDisplayHeading } from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const PlansSection = styled.section`
  background: ${({ theme }) => theme.colors.brand.soft};
  padding: 86px 0;
  ${withAnchorOffset()};

  @media ${deviceMax.tabletWideMax} {
    padding: 66px 0;
  }

  @media ${deviceMax.phoneMax} {
    padding: 57px 0;
  }
`;

export const PlansWrapper = styled(Container)``;

export const PlansHead = styled.div`
  margin-bottom: 46px;
  text-align: center;

  @media ${deviceMax.phoneMax} {
    margin-bottom: 32px;
    text-align: left;
  }
`;

export const PlansTitle = styled.h2`
  ${withDisplayHeading()};

  @media ${deviceMax.phoneMax} {
    font-size: 35px;
  }
`;

export const PlansLead = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 15px;
  margin: 18px auto 0;
  max-width: 550px;

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
    margin-top: 18px;
  }
`;

export const PlansGrid = styled.div`
  display: grid;
  gap: 22px;
  grid-template-columns: repeat(3, 1fr);

  @media ${deviceMax.tabletWideMax} {
    gap: 15px;
  }

  @media ${deviceMax.phoneMax} {
    gap: 18px;
    grid-template-columns: 1fr;
  }
`;

export const SummitStrip = styled.div(
  ({ theme }) => css`
    align-items: center;
    background: ${theme.colors.brand.navy};
    border-radius: ${theme.layout.radius.card};
    color: ${theme.colors.white};
    display: flex;
    gap: 28px;
    margin-top: 24px;
    padding: 25px 30px;

    ${StyledButton}, ${StyledButtonLink} {
      font-size: 12px;
      min-height: 44px;
      white-space: nowrap;
    }

    @media ${deviceMax.desktopSMax} {
      gap: 20px;
    }

    @media ${deviceMax.tabletWideMax} {
      flex-wrap: wrap;

      ${StyledButton}, ${StyledButtonLink} {
        margin-left: auto;
      }
    }

    @media ${deviceMax.phoneMax} {
      display: grid;
      gap: 23px;
      grid-template-columns: 1fr;
      padding: 26px;

      ${StyledButton}, ${StyledButtonLink} {
        font-size: 13px;
        justify-self: start;
        margin: 0;
        min-height: 46px;
      }
    }
  `
);

export const SummitCopy = styled.div`
  flex: 1;

  @media ${deviceMax.tabletWideMax} {
    min-width: 40%;
  }

  p {
    color: #d6dfec;
    font-size: 12px;
    line-height: 1.6;
    margin: 0;

    @media ${deviceMax.phoneMax} {
      font-size: 13px;
    }
  }
`;

export const SummitTitle = styled.h3(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 23px;
    font-weight: 650;
    letter-spacing: -0.035em;
    line-height: 1.2;
    margin: 0 0 7px;

    @media ${deviceMax.phoneMax} {
      font-size: 25px;
    }
  `
);

export const SummitEyebrow = styled.p`
  color: ${({ theme }) => theme.colors.brand.cyan};
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 6px;
  text-transform: uppercase;
`;

export const SummitPrice = styled.div(
  ({ theme }) => css`
    align-items: baseline;
    display: flex;
    gap: 9px;
    white-space: nowrap;

    strong {
      font-family: ${theme.typography.fonts.display};
      font-size: 36px;
      font-weight: 650;
      letter-spacing: -0.04em;
      line-height: 1;

      @media ${deviceMax.phoneMax} {
        font-size: 40px;
      }
    }

    span {
      color: #d0dcea;
      font-size: 11px;

      @media ${deviceMax.phoneMax} {
        font-size: 12px;
      }
    }

    @media ${deviceMax.tabletWideMax} {
      margin-left: auto;
    }

    @media ${deviceMax.phoneMax} {
      justify-self: start;
      margin: 0;
    }
  `
);

export const PlansFineprint = styled.p`
  color: #637287;
  font-size: 10px;
  line-height: 1.8;
  margin: 20px auto 0;
  max-width: 930px;
  text-align: center;

  span {
    display: block;
  }

  @media ${deviceMax.phoneMax} {
    margin-top: 19px;
    text-align: left;
  }
`;
